import axios from 'axios';
import * as alertUtils from '@/utils/alert';
import * as loaderUtils from '@/utils/loader';

export const get = async (url, loader, mensagemSucesso = '') => {
    try {
        if(loader) loaderUtils.addLoarder();
        if (mensagemSucesso !== '') {
            alertUtils.alertSuccess(mensagemSucesso);
        }
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        alertUtils.alertError(error);
        return null;
    } finally {
        if(loader) loaderUtils.removeLoader();
    }
}

export const getOK = async (url, mensagemSucesso = '', mensagemErro = '') => {
    try {
        loaderUtils.addLoarder();
        const response = await axios.get(url);
        //console.log(response.data);
        if (response.data === 'OK') {
            if (mensagemSucesso !== '') {
                alertUtils.alertSuccess(mensagemSucesso);
            }
            return true;
        } else {
            if (mensagemErro !== '') {
                alertUtils.alertError(mensagemErro);
            } else {
                alertUtils.alertError(response.data);
            }
        }
    } catch (error) {
        alertUtils.alertError(error);
    } finally {
        loaderUtils.removeLoader();
    }
    return false;
}

export const postOK = async (url, json, mensagemSucesso = '', mensagemErro = '') => {
    try {
        loaderUtils.addLoarder();
        const response = await axios.post(url, json, {
            headers: {
              'Content-Type': 'application/json'
            }
        });
        if (response.data ===  'OK') {
            if (mensagemSucesso != '') {
                alertUtils.alertSuccess(mensagemSucesso);
            }
            return true;
        } else {
            if (mensagemErro !== '') {
                alertUtils.alertError(mensagemErro);
            } else {
                alertUtils.alertError(response.data);
            }
        }
    } catch (error) {
        alertUtils.alertError(error);
    } finally {
        loaderUtils.removeLoader();
    }
    return false;
}